// Phones get the phone practice shell; tablets and desktops get the desktop
// one. The cut-off is on the screen's short side so rotating the device does
// not change the answer.
const PHONE_MAX_SHORT_SIDE_PX = 768;

export function isPhoneDevice() {
  try {
    const forced = localStorage.getItem('musiker-force-device');
    if (forced === 'mobile') return true;
    if (forced === 'desktop') return false;
  } catch (e) { /* localStorage unavailable */ }

  const shortSide = Math.min(window.screen.width, window.screen.height);
  const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  return shortSide < PHONE_MAX_SHORT_SIDE_PX && hasTouch;
}
